// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__C3uyz","disabled":"FileBtn_disabled__1_muu","warn":"FileBtn_warn__3fYru","fade":"FileBtn_fade__1pDPL"};